import { useAlertContext } from "../alert/AlertContext";
import { ApiContext } from "./ApiContext";
import { useAuthContext } from "../auth/AuthContext";
import { useApiClient } from "../../hooks";
import { useNavigate } from "react-router-dom";

export interface ApiProps {
  children: React.ReactNode;
}

const ApiProvider = ({ children }: ApiProps) => {
  const { user, logout } = useAuthContext();
  const { showAlert } = useAlertContext();
  const navigate = useNavigate();
  const abortController = new AbortController();
  const abort = () => {
    abortController.abort();
  };
  const navigateToMaintenance = () => navigate("/maintenance");
  const client = useApiClient({
    user,
    logout,
    showAlert,
    navigateToMaintenance,
    abortController,
  });

  return (
    <ApiContext.Provider value={{ client, abort }}>
      {children}
    </ApiContext.Provider>
  );
};

export default ApiProvider;
